/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { Typography, Box, Button, List } from "@mui/material";
import DoneOutlinedIcon from '@mui/icons-material/DoneOutlined';
import { getUserSubscription } from "../../store/studentSlice";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty, listOfPlans } from '../../utils/constants';
import { user_type } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { getUpNextData } from "../../store/massageSlice";
import en from "../../nls/en.json";
import { theme, BorderLinearProgress } from "./MyApplicationsStyle";

const MyApplications = (props) => {
  const { isFreePlan = false, setSubscription=false } = props;
  const { savedAnswer } = useSelector(({ studentInfoSlice }) => studentInfoSlice);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userType = savedAnswer?.BASIC_INFORMATION?.user_type;

  const { userSubcription } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { upNextData } = useSelector(({ message }) => message);

  const [firstThreeChecklists, setFirstThreeChecklists] = useState([]);

  useEffect(() => {
    if(!isEmpty(upNextData?.checklists)){
      setFirstThreeChecklists(upNextData?.checklists?.slice(0, 3));  
    }
  }, [upNextData]);

  useEffect(() => {
    dispatch(getUserSubscription());
    dispatch(getUpNextData());
  }, []);

  const navigateToApplications = () => navigate(`/user/applications`);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mb: 3,
        }}
      >
        <Typography variant="h2" sx={{ mb: 0 }}>My Applications</Typography>
        {
          <Button variant="text" onClick={()=>{ navigateToApplications(); }}>View All</Button>
        }
      </Box>

      {(userSubcription[0]?.plan_name === listOfPlans?.COLLEGE_CUROSITY) ?
        <Box>
          <Typography variant="body1">Upgrade to our <strong>Application Accelerator</strong> to track your application process</Typography>
        </Box> :
        <>
          <List
            sx={{ width: "100%", bgcolor: "background.paper", p: 0 }}
            className="msg-list"
          >
            <Box sx={{ mb: 2 }}>
              {firstThreeChecklists?.length ? (firstThreeChecklists?.map((message) => (
                <>
                  <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                    {message.checklist_name}
                  </Typography>
                  <Box display="flex" alignItems="center">
                    <Box width="100%" mr={1}>
                      <BorderLinearProgress
                        variant="determinate"
                        value={message.percentage}

                      />
                    </Box>
                    {message.percentage !== 100 ? (
                      <Box minWidth={35}>
                        <Typography variant="body2" color="textSecondary">
                          {message.percentage}%
                        </Typography>
                      </Box>
                    ) : (
                      <Box minWidth={35}>
                        <DoneOutlinedIcon sx={{ color: "#198754" }} />
                      </Box>
                    )}
                  </Box>
                </>
              ))) : (
                <Typography variant="body1">{userType === user_type.B2C?en.NO_APPLICATIONS_YET:en.NO_APPLICATION_YET_B2B}</Typography>
              )
              }
            </Box>
          </List>
        </>
      }
    </ThemeProvider>
  );
};

export default MyApplications;
